import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import { Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import PublicIcon from '@mui/icons-material/Public';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import SettingsIcon from '@mui/icons-material/Settings';
import TimerIcon from '@mui/icons-material/Timer';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';

const drawerWidth = 256;

// Definiere den aktiven Menüpunkt
const activeMenuItem = 'Homepage-Anfragen';  // Beispiel für den aktiven Menüpunkt

function Sidebar() {
  return (
    <Box component="nav" className="MuiBox-root css-18fxpjn">
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          height: '100vh', // Höhe der Sidebar auf volle Bildschirmhöhe setzen
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#081627', // Grundfarbe der Sidebar
            color: '#ffffff', // Textfarbe in der Sidebar
            borderRight: 'none', // Keine Randlinie rechts
          },
        }}
      >
        <List className="MuiList-root css-1uzmcsd">
          {/* Überschrift */}
          <ListItem
            className="MuiListItem-root MuiListItem-gutters MuiListItem-padding css-qgt9tk"
            sx={{ height: '53px', paddingLeft: '24px', paddingRight: '24px' }}  // Höhe auf 53px setzen
          >
            Google Review Manager 
          </ListItem>

          {/* Menüpunkt: Admin (aktualisierte Beschriftung) */}
          <ListItemButton
            sx={{
              height: '53px',  // Höhe auf 53px setzen
              paddingLeft: '24px',
              paddingRight: '24px',
              minHeight: 'auto',  // Minimale Höhe aufheben
              color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                color: '#4fc3f7',  // Farbe für Hover auf aktivem Menüpunkt
              },
            }}
          >
            <ListItemIcon sx={{ color: 'inherit' }}> {/* Icon-Farbe erbt vom Text */}
              <HomeIcon />
            </ListItemIcon>
            <ListItemText
              primary="Editor" 
              primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
              sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
            />
          </ListItemButton>

          {/* Kunden Section mit geänderter Hintergrundfarbe (aktualisierte Beschriftung) */}
          <Box sx={{ backgroundColor: '#101f33', flexGrow: 1 }}>
            <ListItem
              sx={{ height: '53px', paddingLeft: '24px', paddingRight: '24px', minHeight: 'auto' }}  // Höhe auf 53px setzen
            >
              <ListItemText
                primary="Kunden" 
                primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
              />
            </ListItem>

            {/* Menüpunkt: Homepage-Anfragen (aktualisierte Beschriftung und aktiver Menüpunkt) */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: activeMenuItem === 'Homepage-Anfragen' ? '#4fc3f7' : 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe aktiv/inaktiv
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText
                primary="Homepage-Anfragen" 
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Menüpunkt: Database */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <DnsRoundedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Database"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Weitere Menüpunkte folgen ohne Änderungen... */}
            {/* Menüpunkt: Storage */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <PhotoSizeSelectActualIcon />
              </ListItemIcon>
              <ListItemText
                primary="Storage"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Menüpunkt: Hosting */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <PublicIcon />
              </ListItemIcon>
              <ListItemText
                primary="Hosting"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Menüpunkt: Functions */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <SettingsEthernetIcon />
              </ListItemIcon>
              <ListItemText
                primary="Functions"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Menüpunkt: Machine Learning */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <SettingsInputComponentIcon />
              </ListItemIcon>
              <ListItemText
                primary="Machine Learning"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            <Divider className="MuiDivider-root MuiDivider-fullWidth css-uygmth" />

            {/* Quality Section */}
            <ListItem
              sx={{ height: '53px', paddingLeft: '24px', paddingRight: '24px', minHeight: 'auto' }}  // Höhe auf 53px setzen
            >
              <ListItemText
                primary="Quality"
                primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
              />
            </ListItem>

            {/* Menüpunkt: Analytics */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText
                primary="Analytics"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Menüpunkt: Performance */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <TimerIcon />
              </ListItemIcon>
              <ListItemText
                primary="Performance"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>

            {/* Menüpunkt: Test Lab */}
            <ListItemButton
              sx={{
                height: '33px',  // Höhe auf 33px setzen
                paddingLeft: '24px',
                paddingRight: '24px',
                minHeight: 'auto',  // Minimale Höhe aufheben
                color: 'rgba(255, 255, 255, 0.7)',  // Schriftfarbe setzen
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',  // Hover-Effekt
                  color: '#4fc3f7',  // Schriftfarbe beim Hover
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>
                <PhonelinkSetupIcon />
              </ListItemIcon>
              <ListItemText
                primary="Test Lab"
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                sx={{ '& .MuiTypography-root': { color: 'inherit' } }}  // Entferne spezifische Textfarbe auf span
              />
            </ListItemButton>
            <Divider className="MuiDivider-root MuiDivider-fullWidth css-uygmth" />
          </Box>
        </List>
      </Drawer>
    </Box>
  );
}

export default Sidebar;
